const embedUtils = {
	getEmbedTagProps(embedTag) {
		let embedProps = {};
		if (embedTag) {
			/* to get opening embeded_module tag value to exclude inner content attributes */
			const embedTagVal = embedTag.match(/<embeded_module.*?>/i);
			if (embedTagVal && embedTagVal[0]) {
				const tagVals = embedTagVal[0].match(/[\w-]+="[^"]*"/g);
				embedProps = this.convertArrayPropsToObj(tagVals);
				embedProps.suppress_share = this.setSupressShareFlag(embedProps.suppress_share);
			}
		}
		return embedProps;
	},
	convertArrayPropsToObj(tagVals) {
		let propsObj = {};
		if (tagVals && tagVals.length) {
			propsObj = tagVals.reduce((obj, value) => {
				/* eslint-disable no-param-reassign */
				value = value.split('=');
				obj[value[0]] = value[1].replace(/"/gi, '');
				/* eslint-enable no-param-reassign */
				return obj;
			}, propsObj);
		}
		return propsObj;
	},
	removeDuplicatesFromArray(arr) {
		// removing duplicates
		return arr.filter((c, index) => arr.indexOf(c) === index);
	},
	/* eslint-disable camelcase */
	suppressEmbedModule(config, s_packageType) {
		let suppressModule = false;
		let suppresFromFED = false;
		let suppresFromSite = false;
		const isFedPage = (s_packageType === 'Editorial Destination');
		const isSitePage = !isFedPage;

		/* eslint-disable no-param-reassign */
		config = config || '';
		if (config) {
			suppresFromFED = this.setSupressShareFlag(config.suppress_from_fed);
			suppresFromSite = this.setSupressShareFlag(config.suppress_from_site);

			if (isFedPage && suppresFromFED) {
				suppressModule = true;
			} else if (isSitePage && suppresFromSite) {
				suppressModule = true;
			}
		}
		return suppressModule;
	},
	getCustomFbUrl(config) {
		let fbQuote = '';
		let customfbUrl = '';
		const baseUrl = 'https://www.facebook.com/sharer/sharer.php?';
		if (config) {
			if (config.description && config.title) {
				fbQuote = `${config.title} - ${config.description}`;
			} else if (config.description) {
				fbQuote = config.description || '';
			} else {
				fbQuote = config.title || '';
			}
			const url = `&u=${encodeURIComponent(config.url || '')}`;
			const quote = `&quote=${encodeURIComponent(fbQuote || '')}`;
			customfbUrl = baseUrl + url + quote;
		}
		return customfbUrl;
	},
	setSupressShareFlag(suppressValue) {
		if (suppressValue === true || suppressValue === 'true') {
			return true;
		}
		return false;
	},
	isMobile() {
		let isMobile = false;
		if (typeof window !== 'undefined') {
			// eslint-disable-next-line no-restricted-globals
			if (screen.width < 768) {
				isMobile = true;
			}
		}
		return isMobile;
	},
	getImageSize() {
		return '?resize=750:*';
	},
	getHeaderTitle(config) {
		let title = '';
		if (config) {
			title = config.asset_title ? config.asset_title : '';
		}
		return title;
	},
};

export default embedUtils;
